import useBootstrapData from '@/hooks/useBootstrapData'
import useSeti from '@/hooks/useSeti'
import analytics from '@/shared-utils/analytics'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { ERROR_TYPE_GA4_MAP, type PkgErrorType } from './errorTypes'

const PackagesDesktop = dynamic(() => import('./Desktop'))
const PackagesMobile = dynamic(() => import('./Mobile'))

function Packages() {
  useSeti({ experimentCode: 'AA_PACKAGES_LP' }) // AA Test: Unconditional firing and no visual changes
  const { query } = useRouter()
  const { isMobile = false } = useBootstrapData()
  const isFromPkgError =
    typeof query['redirect-source'] === 'string' && query['redirect-source'].toLowerCase() === 'error'
  const messageQueryParam = query['message']

  const hasAdvancedSearchCookie =
    typeof document !== 'undefined' && document.cookie.includes('pkgAdvancedSearch=true')

  useSeti({
    experimentCode: 'PKG_ERROR_PERSIST_ADVANCED_SEARCH',
    shouldFireImpression: isFromPkgError && hasAdvancedSearchCookie,
  })

  useEffect(() => {
    if (isFromPkgError && hasAdvancedSearchCookie) {
      analytics.fireGA4Event({
        event: 'display',
        attributes: {
          type: 'pkg_landing_search_redirect_error',
          item_name: '',
          page_name: 'landing_page',
          product_name: 'bundle',
        },
      })
    }
  }, [isFromPkgError, hasAdvancedSearchCookie])

  useEffect(() => {
    analytics.fireGA4Event({
      event: 'page_view',
      attributes: {
        page_name: 'landing',
        page_desc: 'bundle',
      },
    })
  }, [])

  useEffect(() => {
    if (isFromPkgError) {
      analytics.logError({
        message: 'PKG Error Redirect',
        page: '/vacationpackages',
        errorMessage: messageQueryParam,
      })
      analytics.fireGA4Event({
        event: 'display',
        attributes: {
          type: 'pkg_landing_search_redirect_error',
          page_name: 'landing',
          product_name: 'bundle',
        },
      })

      const ga4Type =
        typeof messageQueryParam === 'string'
          ? ERROR_TYPE_GA4_MAP[messageQueryParam as PkgErrorType]
          : undefined
      if (ga4Type) {
        analytics.fireGA4Event({
          event: 'display',
          attributes: {
            type: ga4Type,
            page_name: 'landing_page',
            product_name: 'bundle',
          },
        })
      }
    }
  }, [isFromPkgError, messageQueryParam])

  return isMobile ? <PackagesMobile /> : <PackagesDesktop />
}

export default Packages
